import React from 'react';
import {FormTemplateField} from '../../../others/'
import {Input, Textarea, Dropdown} from '../../../form'

let VisualSummaryField = props => {
  const { baseName, baseFieldValues, isTemplate, isOpen } = props;
  return (
    <div className="card-body">
      <div className="row">
        <FormTemplateField
          isTemplate={isTemplate}
          name={`${baseName}[fields][eye]`}
          baseName={`${baseName}[fields][eye]`}
          fieldValues={baseFieldValues['eye']}
          component={Dropdown} 
          isOpen={isOpen}
          data={[{key: 'od', value: 'OD'}, {key: 'os', value: 'OS'}, {key: 'ou', value: 'OU'}]} 
          textField="value" 
          valueField="key" 
          wrapperClasses="col-6 form-group label-icons"
         />
        
        <FormTemplateField
          isTemplate={isTemplate}
          name={`${baseName}[fields][dilation]`}
          baseName={`${baseName}[fields][dilation]`}
          fieldValues={baseFieldValues['dilation']}
          component={Dropdown} 
          isOpen={isOpen}
          data={[{key: 'yes', value: 'Yes'}, {key: 'no', value: 'No'}]} 
          textField="value" 
          valueField="key" 
          wrapperClasses="col-6 form-group label-icons"
         />
        
        <FormTemplateField
          isTemplate={isTemplate}
          name={`${baseName}[fields][location]`}
          baseName={`${baseName}[fields][location]`}
          fieldValues={baseFieldValues['location']}
          component={Input} 
          className="form-control"
          wrapperClasses="col-6 form-group label-icons"
          type="findingField"
         />
        
        <FormTemplateField
          isTemplate={isTemplate}
          name={`${baseName}[fields][plug_type]`}
          baseName={`${baseName}[fields][plug_type]`}
          fieldValues={baseFieldValues['plug_type']}
          component={Input} 
          isOpen={isOpen}
          className="form-control"
          wrapperClasses="col-6 form-group label-icons"
          type="findingField"
         />
        
        <FormTemplateField
          isTemplate={isTemplate}
          name={`${baseName}[fields][pre_medication]`}
          baseName={`${baseName}[fields][pre_medication]`}
          fieldValues={baseFieldValues['pre_medication']}
          component={Input}
          isOpen={isOpen}
          placeholder="Type to search"
          className="form-control"
          wrapperClasses="col-6 form-group label-icons"
          type="findingField"
         />
        
        <FormTemplateField
          isTemplate={isTemplate}
          name={`${baseName}[fields][post_medication]`}
          baseName={`${baseName}[fields][post_medication]`}
          fieldValues={baseFieldValues['post_medication']}
          component={Input}
          isOpen={isOpen}
          placeholder="Type to search"
          className="form-control"
          wrapperClasses="col-6 form-group label-icons"
          type="findingField"
         />
        
        <FormTemplateField
          isTemplate={isTemplate}
          name={`${baseName}[fields][comments]`}
          baseName={`${baseName}[fields][comments]`}
          fieldValues={baseFieldValues['comments']}
          component={Textarea}
          isOpen={isOpen} 
          rows={3}
          className="form-control"
          wrapperClasses="col-12 form-group label-icons"
         />
        
      </div>
    </div>
  )
}
export default VisualSummaryField;